import {HostBinding, Input} from '@angular/core';

export abstract class AbstractIcon {
    @HostBinding('style.fill') @Input() public color: string;
    @HostBinding('style.height.px') @Input() public height: number;
    @Input() public name: string;
    @HostBinding('style.width.px') @Input() public width: number;
}
